var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7631 7.79028H17.5131V4.04028",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8614 14.8614C13.8999 15.8229 12.6749 16.4776 11.3412 16.7429C10.0076 17.0082 8.62529 16.872 7.36905 16.3517C6.11281 15.8313 5.03908 14.9501 4.28365 13.8196C3.52821 12.689 3.125 11.3598 3.125 10C3.125 8.64026 3.52821 7.31105 4.28365 6.18046C5.03908 5.04987 6.11281 4.16868 7.36905 3.64833C8.62529 3.12798 10.0076 2.99183 11.3412 3.2571C12.6749 3.52238 13.8999 4.17716 14.8614 5.13864L17.513 7.79029",
    stroke: "#333333",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.fa83aa61732df18d3f1c48ca4a47cf79.svg";
export { ForwardRef as ReactComponent };